<div class="flex flex-col max-h-[90vh]">
    <button type="button" class="rounded-full bg-[#00000066] px-3 py-2 ml-auto mb-3 shrink-0 z-10" (click)="onCancel()">
        <i class="las la-times text-white text-xl"></i>
    </button>

    <div class="overflow-y-auto rounded-lg bg-white flex-1">
        <form class="flex flex-col gap-6 px-10 py-6 text-cool-grey-5" [formGroup]="form" (submit)="onSearch()">
            <div class="flex flex-col gap-y-2">
                <div class="text-2xl" translate>Choose the Machine That Fits Your Needs</div>
                <div class="text-cool-grey-4 text-sm" translate>
                    The suggested machines are recommended based on general criteria. For a personalised recommendation,
                    please contact our specialist.
                </div>
                <div class="text-cool-grey-4 text-[0.625rem]" translate>
                    Please note that the recommender is base on estimates and are we will not be liable for any damages
                    or lost due to under/over seizing.
                </div>
                <div class="border-t border-cool-grey w-full"></div>
            </div>

            <div>
                <div translate>1. What is your heaviest cargo?</div>

                <div class="text-xs text-cool-grey-3" translate>
                    Choose a machine that can safely handle your heaviest load at minimum
                </div>

                @if (filterRanges) {
                    <div class="mt-4 grid gap-y-2 text-center md:w-1/3">
                        <div class="text-xs text-cool-grey-3 font-medium">
                            <span>{{ form.value.minLoadCapacity | number: APP_AMOUNT_FORMAT }} - </span>
                            <span>{{ form.value.maxLoadCapacity | number: APP_AMOUNT_FORMAT }}kg</span>
                        </div>
                        <mat-slider
                            step="100"
                            [min]="filterRanges.minLoadCapacity"
                            [max]="filterRanges.maxLoadCapacity">
                            <input matSliderStartThumb formControlName="minLoadCapacity" />
                            <input matSliderEndThumb formControlName="maxLoadCapacity" />
                        </mat-slider>
                    </div>
                }
            </div>

            <div>
                <div translate>2. What is the highest lifting height?</div>

                <div class="text-xs text-cool-grey-3" translate>
                    Choose a machine that can lift to your maximum required height.
                </div>

                @if (filterRanges) {
                    <div class="mt-4 grid gap-y-2 text-center md:w-1/3">
                        <div class="text-xs text-cool-grey-3 font-medium">
                            <span>{{ form.value.minLiftHeight | number: APP_AMOUNT_FORMAT }} - </span>
                            <span>{{ form.value.maxLiftHeight | number: APP_AMOUNT_FORMAT }}mm</span>
                        </div>
                        <mat-slider step="1000" [min]="filterRanges.minLiftHeight" [max]="filterRanges.maxLiftHeight">
                            <input matSliderStartThumb formControlName="minLiftHeight" />
                            <input matSliderEndThumb formControlName="maxLiftHeight" />
                        </mat-slider>
                    </div>
                }
            </div>

            <div>
                <div translate>3. Where will the machine be used most often?</div>

                <div class="flex gap-4 mt-2">
                    @for (
                        work of WORKING_ENVIRONMENTS_OPTIONS | keyvalue: sortNumberEnumConstantInterfaceAsc;
                        track work.value
                    ) {
                        <button
                            type="button"
                            class="filter-btn"
                            [class.selected]="isWorkingEnvironmentSelected(work.key)"
                            (click)="toggleWorkingEnvironment(work.key)">
                            {{ work.value.label }}
                        </button>
                    }
                </div>
            </div>

            <div>
                <div translate>4. Are your aisles narrow or wide?</div>

                <div class="flex gap-4 mt-2 flex-wrap">
                    @for (
                        aisle of AISLE_WIDTH_OPTIONS | keyvalue: sortNumberEnumConstantInterfaceAsc;
                        track aisle.key
                    ) {
                        <button
                            type="button"
                            class="filter-btn"
                            [class.selected]="isAisleWidthSelected(aisle.key)"
                            (click)="toggleAisleWidth(aisle.key)">
                            <div>{{ aisle.value.label }}</div>
                            <div class="text-cool-grey-3 text-xs mt-2">{{ aisle.value.description }}</div>
                        </button>
                    }
                </div>
            </div>

            <div class="flex justify-between items-center">
                <button
                    class="px-4 py-3 rounded-lg border border-solid border-cool-grey hover:bg-cool-grey"
                    type="button"
                    (click)="onCancel()">
                    Cancel
                </button>

                <button class="main-button w-fit" type="submit">
                    <div class="button-label">
                        <div class="label-content" translate>Search</div>
                    </div>
                    <div class="star">
                        <div class="icon"></div>
                    </div>
                </button>
            </div>
        </form>
    </div>
</div>
